import { BundleForm } from "../BundleForm";

export interface AddBundleProps {}

export const AddBundle = () => {
  return <BundleForm />;
};
